import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QueryAreaComponent } from './query-area.component';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material';
import { MatCardModule } from '@angular/material/card';


@NgModule({
  declarations: [
    QueryAreaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule,
    MonacoEditorModule.forRoot()
  ],
  providers: [],
  exports: [QueryAreaComponent]
})
export class QueryAreaModule { }
